module.exports = __webpack_public_path__ + "img/fukidashi.2ed80cd2.svg";